<template>
  <v-footer
    dark
    height="auto"
    class="mt-5"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="grey darken-1">
        <v-layout
            justify-center
            row
            wrap
            >
            <v-btn
                color="white"
                to="/policy"
                flat
            >
                {{ privateDataPolicyNavTitle }}
            </v-btn>
            <v-btn
                color="white"
                to="/imprint"
                flat
            >
                {{ imprintNavTitle }}
            </v-btn>
            <v-btn
                color="white"
                to="/contact"
                flat
            >
                {{ contactNavTitle }}
            </v-btn>
            <v-btn
                color="white"
                href="http://webmail.all-inkl.com" 
                target="_blank"
                flat
            >
                Email
            </v-btn>
        </v-layout>

      </v-card-title>

      <v-card-actions class="grey darken-3 justify-center">
        &copy;2018 — <strong class="ml-1">Instituts für Berufsbildung Niedersachsen e.V.</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
        ...mapState('ContactModule', [
                                        'privateDataPolicyNavTitle',
                                        'imprintNavTitle',
                                        'contactNavTitle',
                                        ]),
    },
  }
</script>